import DeleteDialog from './DeleteDialog';
import SuccessDialog from './SuccessDialog';
import ClassesTable from './ClassesTable';
import { useClassesInfo } from '../hooks/useClassesInfo';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { AlertCircle } from 'lucide-react';

const ClassesInfo = () => {
  const {
    state: {
      appointments,
      clubNames,
      deleteDialog,
      cancelSuccessDialog,
      selectedClass,
      userName,
      errorDialog,
      errorMessage,
    },
    actions: {
      setDeleteDialog,
      handleConfirmDelete,
      handleCancelSuccessClose,
      onClickDeleteClasses,
      handleErrorClose,
      setErrorDialog,
    },
  } = useClassesInfo();

  return (
    <>
      <DeleteDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={handleConfirmDelete}
      />
      <SuccessDialog
        isOpen={cancelSuccessDialog}
        onClose={handleCancelSuccessClose}
        selectedClass={selectedClass}
        clubNames={clubNames}
        userName={userName}
      />
      <Dialog open={errorDialog} onOpenChange={setErrorDialog}>
        <DialogContent className="overflow-hidden p-0 sm:max-w-[425px]">
          <div className="flex items-center justify-center bg-red-50 p-6">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
          </div>
          <div className="p-6">
            <DialogHeader>
              <DialogTitle className="mb-2 text-center text-xl">Ошибка</DialogTitle>
              <DialogDescription className="text-center text-base text-gray-600">
                {errorMessage}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="mt-6">
              <Button
                onClick={handleErrorClose}
                className="w-full bg-red-600 text-white hover:bg-red-700"
                size="lg">
                Закрыть
              </Button>
            </DialogFooter>
          </div>
        </DialogContent>
      </Dialog>
      <ClassesTable
        appointments={appointments}
        clubNames={clubNames}
        userName={userName}
        onClickDeleteClasses={onClickDeleteClasses}
      />
    </>
  );
};

export default ClassesInfo;
